/**
 * BudgetPromptDialog — overlay shown when a user hits their personal AI credit
 * cap and the server offers a cheaper fallback. Phase 6 extract from
 * pages/SenseAI.jsx.
 */
import React from "react";
import { Button } from "@/components/ui/button";

export default function BudgetPromptDialog({ budgetPrompt }) {
    if (!budgetPrompt) return null;
    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="budget-prompt-overlay">
            <div className="bg-card border border-border rounded-sm p-6 max-w-md w-full" data-testid="budget-prompt-dialog">
                <div className="flex items-start gap-3 mb-4">
                    <div className="h-9 w-9 shrink-0 rounded-full bg-amber-500/15 flex items-center justify-center">
                        <span className="text-amber-500 text-lg">⚠</span>
                    </div>
                    <div>
                        <div className="text-base font-medium">Personal AI credit cap reached</div>
                        <div className="text-xs text-muted-foreground mt-1 font-mono">
                            {budgetPrompt.used.toLocaleString()} / {budgetPrompt.cap.toLocaleString()} credits used this month
                        </div>
                    </div>
                </div>
                <p className="text-sm mb-4">
                    Continue with a cheaper fallback model — <b className="font-mono">{budgetPrompt.fallback?.model}</b> via <b className="capitalize">{budgetPrompt.fallback?.provider}</b>?
                    Your retry will count against this fallback's price, not your blocked default.
                </p>
                <div className="flex items-center gap-2 justify-end">
                    <Button variant="ghost" onClick={budgetPrompt.onCancel} data-testid="budget-prompt-cancel">Cancel</Button>
                    <Button onClick={budgetPrompt.onConfirm} data-testid="budget-prompt-confirm">Continue with fallback</Button>
                </div>
            </div>
        </div>
    );
}
